import { render, staticRenderFns } from "./referrerlist.vue?vue&type=template&id=0acfef74&scoped=true"
import script from "./referrerlist.vue?vue&type=script&lang=js"
export * from "./referrerlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acfef74",
  null
  
)

export default component.exports